"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecord = isRecord;
exports.isMapLike = isMapLike;
exports.isArrayLike = isArrayLike;
exports.readManifestField = readManifestField;
exports.readOptionalStringField = readOptionalStringField;
exports.readStringField = readStringField;
exports.readNumberField = readNumberField;
exports.readListField = readListField;
exports.assertNonNegativeInteger = assertNonNegativeInteger;
function isRecord(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
function isMapLike(value) {
    return isRecord(value) && typeof value.get === 'function';
}
function isArrayLike(value) {
    return isRecord(value) && typeof value.toArray === 'function';
}
function readManifestField(value, key) {
    if (isMapLike(value))
        return value.get(key);
    if (isRecord(value))
        return value[key];
    return undefined;
}
function readOptionalStringField(value, key) {
    const field = readManifestField(value, key);
    return typeof field === 'string' ? field : undefined;
}
function readStringField(value, key) {
    return readOptionalStringField(value, key) ?? '';
}
function readNumberField(value, key) {
    const field = readManifestField(value, key);
    return typeof field === 'number' ? field : Number.NaN;
}
/** A list field stored as an array or a Y.Array-like value. */
function readListField(value, key) {
    const field = readManifestField(value, key);
    if (Array.isArray(field))
        return field;
    if (isArrayLike(field))
        return field.toArray();
    return undefined;
}
function assertNonNegativeInteger(value, label) {
    if (!Number.isInteger(value) || value < 0) {
        throw new RangeError(`${label} must be a non-negative integer`);
    }
}
